import gql from 'graphql-tag';

export const getDeviceBatch = gql`
  query ($serial: String) {
    getDeviceBatch (serial: $serial) {
      deviceBatchId
      serial
      remark
      status
      date
      iBeacons {
        deviceId
        uuid
        major
        minor
      }
      eddystones {
        deviceId
        namespace
        instance
      }
      readers {
        deviceId
        mac
      }
      bluetoothHubs {
        deviceId
        serial
      }
      gateways {
        deviceId
        serial
      }
      devices {
        model
      }
    }
  }
`
